module.exports = __webpack_public_path__ + "img/NADER.015f9432.png";